export enum MetadataType {
  text = 0,
  number = 1,
  date = 2,
}
